import { omit } from 'lodash';
import { isObjectEmpty } from '../helper';

export const saveFormDataInLocalStorage = (options = {}) => {
  const { record, type, id, item } = options;
  const localData = JSON.parse(localStorage.getItem(item)) || {};
  if (isObjectEmpty(localData)) {
    if (isObjectEmpty(localData[type])) {
      localData[type][id] = record;
    } else {
      localData[type] = { [id]: record };
    }
  } else {
    localData[type] = { [id]: record };
  }
  if (['', 'null', null].indexOf(localData) < 0) {
    localStorage.setItem(item, JSON.stringify(localData));
  }
  return localData;
};

export const removeItemsInLocalStorage = (bucket, item, key) => {
  const localData = localStorage.getItem(bucket);
  if (!isObjectEmpty(localData)) return;
  let parsedData = JSON.parse(localData);
  if (!isObjectEmpty(parsedData[item][key])) return;
  const bucketData = omit(parsedData[item], key);
  parsedData = { ...parsedData, [item]: bucketData };
  if (['', 'null', null].indexOf(parsedData) < 0) {
    localStorage.setItem(bucket, JSON.stringify(parsedData));
  }
};

export default saveFormDataInLocalStorage;
